import { ComponentProps } from "react";
import { ButtonV2, H1, H2 } from "../../../../Atoms";

interface ICardTypeHomeProps extends ComponentProps<"div"> {
  icon: React.ReactNode;
  title: string;
  buttonText: string;
  buttonAction: () => void;
}

export const CardTypeHome = ({
  children,
  buttonAction,
  buttonText,
  icon,
  title,
}: ICardTypeHomeProps) => {
  return (
    <div className="w-full max-w-80 bg-[#E7EDEC] rounded-[10px] px-4 py-8 flex flex-col justify-between gap-6">
      <div className=" flex flex-col gap-6">
        <div>{icon}</div>
        <H2>{title}</H2>
        {children}
      </div>
      <ButtonV2 onClick={() => buttonAction()}>
        {buttonText}{" "}
        <img
          src="/assets/svgs/icon-arrow-forward.svg"
          alt="icone seta para direita"
        />{" "}
      </ButtonV2>
    </div>
  );
};
